/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckQuorumRequest } from '../models/CheckQuorumRequest';
import type { NetworkInfoDto } from '../models/NetworkInfoDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValidatorPrefillControllerService {

    /**
     * @param requestBody
     * @returns boolean OK
     * @throws ApiError
     */
    public static checkQuorum(
        requestBody: CheckQuorumRequest,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/validators/prefill/check-quorum',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @returns NetworkInfoDto OK
     * @throws ApiError
     */
    public static getNetworkInfo(): CancelablePromise<NetworkInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/validators/prefill/network-info',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

}
